window.casino = window.casino || {};
var repos = (window.casino.repos = window.casino.repos || {});

repos.sessionRepo = (function () {
  var url = "api/session";

  var get = function () {
    let session_id = casino.utils.getCookie("session_id");
    session_id = !session_id ? "" : session_id.toLowerCase().replaceAll('-', '');

    return fetch(url + "/" + session_id, {
      method: "GET",
      headers: repos.base.headers(),
      credentials: repos.base.credentials,
    })
      .then(casino.repos.base.checkResponse)
      .then(function (response) {
        return response.json().then(function (sesija) {
          if (sesija && sesija.antiForgeryToken)
            casino.config.antiForgeryToken = sesija.antiForgeryToken;

          return sesija;
        });
      })
      .catch(casino.repos.base.handleNetworkException);
  };

  var create = function (username, password, deviceId) {
    return fetch(url, {
      method: "POST",
      credentials: repos.base.credentials,
      headers: repos.base.headers(),
      body: JSON.stringify({
        username: username,
        password: password,
        deviceId: deviceId,
      }),
    })
      .then(casino.repos.base.checkResponse)
      .then(function (response) {
        return response.json().then(function (login) {
          if (login && login.sesija.antiForgeryToken)
            casino.config.antiForgeryToken = login.sesija.antiForgeryToken;

          return login;
        });
      })
      .catch(casino.repos.base.handleNetworkException);
  };

  var remove = function (callback) {
    return fetch(url, {
      method: "DELETE",
      headers: repos.base.headers(),
      credentials: repos.base.credentials,
    })
      .then(casino.repos.base.checkResponse)
      .then(function (response) {
        response.json().then(function (odjava) {
          if (odjava && odjava.sesija.antiForgeryToken)
            casino.config.antiForgeryToken = odjava.sesija.antiForgeryToken;
        });
      })
      .catch(casino.repos.base.handleNetworkException);
  };

  var create2FA = function (code2FA, refID2FA, deviceId) {
    return fetch(url, {
      method: "POST",
      credentials: repos.base.credentials,
      headers: repos.base.headers(),
      body: JSON.stringify({
        code2FA: code2FA,
        refID2FA: refID2FA,
        deviceId: deviceId,
      }),
    })
      .then(casino.repos.base.checkResponse)
      .then(function (response) {
        return response.json().then(function (login) {
          if (login && login.sesija.antiForgeryToken)
            casino.config.antiForgeryToken = login.sesija.antiForgeryToken;

          return login;
        });
      })
      .catch(casino.repos.base.handleNetworkException);
  };

  return {
    get: get,
    create: create,
    create2FA: create2FA,
    remove: remove,
  };
})();
